<template>
	<div class="w-full tracking-wide pl-2 pr-6 space-y-4">
		<!-- <div class="border p-4">

			<div class="flex text-ihh-midnight-gray font-semibold text-base mb-4 md:mb-1">
				Refinements
				<div class="flex w-full justify-end">
					<div @click.stop="showCategories" class="flex flex-col relative transition-transform duration-300 ease-in-out cursor-pointer">
						<svg class="w-8" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
							<polygon points="50,70 30,50 35,45 50,60 65,45 70,50" class="fill-ihh-midnight-gray" />
						</svg>
					</div>
				</div>
			</div>

			<div v-if="!filterApplied" class="flex w-full justify-start my-4 gap-x-1 capitalize m-auto items-center">
				<button class="flex items-center bg-ihh-gray/40 rounded py-2">
					<div @click="cartItems" class="flex group w-5 h-5 justify-around rounded-full font-bold text-xl text-ihh-midnight-gray">
						<div class="m-auto items-center flex w-full justify-center">
							<div class="rotate-45 absolute rounded bg-ihh-slate-gray py-[0.5px] rounded-lg px-[5px]"></div>
							<div class="-rotate-45 rounded bg-ihh-slate-gray py-[0.5px] rounded-lg px-[5px]"></div>
						</div>
					</div>
					<div class="pr-2 font-semibold text-ihh-midnight-gray text-xs text-end capitalize">Birth Kit Items</div>
				</button>
			</div>
		</div> -->

		<div class="flex w-full relative border overflow-hidden group text-sm font-thin text-black relative">
			<input
				type="text"
				id="name"
				v-model="filters.query"
				required
				class="px-3 bg-transparent focus:border focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon w-full text-sm font-light text-black placeholder-ihh-gray relative"
				placeholder="Search"
			/>
			<button class="duration-100 transition bg-transparent hover:bg-ihh-salmon/40 right-0 p-3 border-l border-ihh-light-gray">
				<img src="/images/ob-search0129.svg" class="w-6 h-6 duration-300 transition ease-in-out" alt="Search Icon" />
			</button>
		</div>

		<div class="">
			<div class="border p-4">
				<div class="flex text-ihh-midnight-gray font-bold text-sm mb-4 md:mb-1 justify-between">
					Category
					<button @click="categoriesExpanded = !categoriesExpanded" class="m-auto items-center flex w-full justify-end">
						<svg v-if="!categoriesExpanded" class="w-3" viewBox="30 45 40 25" xmlns="http://www.w3.org/2000/svg">
							<polygon points="50,70 30,50 35,45 50,60 65,45 70,50" class="fill-ihh-midnight-gray" />
						</svg>
						<div v-else class="flex w-full justify-end">—</div>
					</button>
				</div>

				<!-- Top of Project -->
				<div v-show="categoriesExpanded">
					<div
						v-for="c in store.categories.filter((c) => !c.parentId && c.name != 'Brands')"
						:key="c.bcid"
						class="flex flex-col items-start m-auto border-l-2 border-ihh-filters-light-gray"
					>
						<div class="flex items-center">
							<div class="-translate-y-[13px] w-4 h-7 border-b-2 border-ihh-filters-light-gray"></div>
							<button
								v-if="c.subcategories"
								@click="toggleOpenSections(c)"
								class="mr-2 p-2 flex items-center justify-center text-base bg-ihh-filters-light-gray text-ihh-filters-dark-gray w-3 h-3 rounded-full font-semibold cursor-pointer overflow-hidden z-10"
								:class="openSections.includes(c.bcId) ? 'rounded-full border bg-white -ml-1' : ''"
							>
								{{ openSections.includes(c.bcId) ? '-' : '+' }}
							</button>
							<div class="flex items-center w-full text-sm">
								<label
									class="custom-checkbox relative inline-block overflow-hidden w-4 h-4 bg-transparent rounded border border-ihh-filters-light-gray cursor-pointer mr-2"
								>
									<input
										v-model="filters.categories"
										:value="c"
										:indeterminate="filters.categories.some((cat) => cat.parentId == c.id)"
										type="checkbox"
										class="absolute opacity-0 w-0 h-0"
									/>
									<span class="checkmark absolute inset-0 flex items-center justify-center hidden text-ihh-white/90 text-xs">✓</span>
								</label>
								<div class="text-ihh-midnight-gray text-start">{{ c.name }}</div>
								<!-- <div class="bg-ihh-pink text-ihh-salmon rounded px-2 ml-2">{{ c?.count || 0 }}</div> -->
							</div>
						</div>

						<!-- Extended section -->
						<div v-show="openSections.includes(c.bcId)">
							<div v-for="sc in c.subcategories" :key="sc.bcId" class="ml-4 flex items-center">
								<div class="-translate-y-[13px] w-16 h-7 border-l-2 border-b-2 border-ihh-filters-light-gray"></div>
								<div class="flex items-center w-full">
									<label
										class="custom-checkbox relative inline-block overflow-hidden w-4 h-4 bg-transparent rounded border border-ihh-filters-light-gray cursor-pointer mr-2"
									>
										<input v-model="filters.categories" :value="sc" type="checkbox" class="absolute opacity-0 w-0 h-0" />
										<span class="checkmark absolute inset-0 flex items-center justify-center hidden text-ihh-white/90 text-xs">✓</span>
									</label>
									<div class="text-ihh-midnight-gray text-start text-sm">{{ sc?.name }}</div>
									<!-- <div class="bg-ihh-pink text-ihh-salmon rounded px-2 ml-2">{{ sc?.count || 0 }}</div> -->
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Bottom of Project -->
			</div>
		</div>

		<div class="">
			<div class="border p-4">
				<div class="flex text-ihh-midnight-gray font-bold text-sm mb-4 md:mb-1 justify-between">
					Brand
					<button @click="brandsExpanded = !brandsExpanded" class="m-auto items-center flex w-full justify-end">
						<svg v-if="!brandsExpanded" class="w-3" viewBox="30 45 40 25" xmlns="http://www.w3.org/2000/svg">
							<polygon points="50,70 30,50 35,45 50,60 65,45 70,50" class="fill-ihh-midnight-gray" />
						</svg>
						<div v-else class="flex w-full justify-end">—</div>
					</button>
				</div>

				<div class="space-y-2" v-show="brandsExpanded">
					<div v-for="c in store.categories.filter((c) => c.parentId == 151)" :key="c.bcid" class="flex items-center w-full pr-4">
						<label
							class="custom-checkbox relative inline-block overflow-hidden w-4 h-4 bg-transparent rounded-sm border border-ihh-filters-light-gray cursor-pointer mr-4"
						>
							<input v-model="filters.categories" :value="c" type="checkbox" class="absolute opacity-0 w-0 h-0" />
							<span class="checkmark absolute inset-0 flex items-center justify-center hidden text-white text-xs"> ✓ </span>
						</label>
						<div class="text-ihh-slate-gray text-sm">{{ c.name }}</div>
					</div>
				</div>
			</div>

			<div class="border border-ihh-filters-light-gray p-4">
				<div class="flex text-ihh-midnight-gray font-bold text-sm">
					Price
					<!-- <div class="flex w-full justify-end">—</div> -->
				</div>
				<div class="">
					<PriceRange v-model="filters.price" />
				</div>
			</div>
		</div>

		<!-- Footer Section -->
		<div class="flex w-full bottom-0 sticky border-t-2 border-ihh-light-gray h-fit grow text-ihh-midnight-gray z-20">
			<div class="bg-white overflow-auto py-8 px-6 w-full flex flex-col rounded-t-xl">
				<div class="flex-col space-y-4 w-full pt-6">
					<!-- <button
										class="flex text-center items-center justify-center text-sm md:text-base text-ihh-white py-4 uppercase tracking-widest hover:text-ihh-midnight-gray px-10 w-full rounded-md bg-ihh-dark-salmon hover:bg-ihh-salmon duration-150 transition tracking-wide font-semibold"
									>
										Apply Filter
									</button> -->
					<button
						@click="filters = JSON.parse(JSON.stringify(originalFilters))"
						class="cursor-pointer flex text-center items-center justify-center text-sm md:text-base py-4 uppercase tracking-widest text-white px-10 w-full rounded-md bg-ihh-slate-gray/70 hover:bg-ihh-slate-gray duration-150 transition tracking-wide font-semibold"
					>
						Reset Filters
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { useModel } from '../../../helpers/model'
// import VueSlider from 'vue-slider-component'
// import 'vue-slider-component/theme/default.css';
import PriceRange from './price-range.vue'

export default {
	props: ['modelValue'],
	setup(props, { emit }) {
		return {
			filters: useModel(props, emit, 'modelValue'),
		}
	},
	components: { PriceRange },
	inject: ['store'],
	data() {
		return {
			categoriesExpanded: false,
			brandsExpanded: false,
			originalFilters: JSON.parse(JSON.stringify(this.filters)),
			filterApplied: false,
			query: null,
			openSections: [],
		}
	},
	methods: {
		toggleOpenSections(item) {
			if (this.openSections.includes(item.bcId)) {
				this.openSections = this.openSections.filter((i) => i !== item.bcId)
			} else {
				this.openSections.push(item.bcId)
			}
		},
	},
}
</script>

<style scoped>
/* Custom slider styles */
.custom-slider .vue-slider-rail {
	background-color: var(--ihh-white);
}

.custom-slider .vue-slider-dot {
	background-color: var(--ihh-salmon);
}

.custom-slider .vue-slider-process {
	background-color: var(--ihh-salmon);
}
</style>
